import React from 'react'
import {
  PeopleOutline,
  Event,
  Apartment,
  Settings,
  MeetingRoomOutlined,
  NotificationsActiveOutlined,
  CasesOutlined,
  ImageOutlined,
  MilitaryTech,
  Group,
  HowToVote,
  HowToReg,
  Badge,
  MailOutline,
  SchoolOutlined,
  Forum,
  NotificationsNoneOutlined,
  SupervisorAccount
} from '@material-ui/icons'
import Attendees from 'views/admin/attendees/Attendees'
import Building from 'views/admin/building/Building'
import Config from 'views/admin/configuration/Config'
import Conference from 'views/admin/conference/Conference'
import Announcements from 'views/admin/announcements/Announcements'
import EventCards from 'views/admin/eventCards/EventCards'
import SponsorshipLevels from 'views/admin/sponsorshipLevels/SponsorshipLevels'
import Admins from 'views/admin/conf-admins/Admins'
import { Roles } from 'constants/index'
import MyConference from 'views/admin/conference/MyConference'
import Polls from 'views/admin/polling/Polls'
import ConferenceSettings from 'views/admin/EmailTemplates'
import Attendance from 'views/admin/attendance/Attendance'
import BadgesV1 from 'views/admin/BadgesV1/BadgesV1'
import DefaultEmailTemplates from 'views/admin/DefaultEmailTemplates/DefaultEmailTemplates'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { Container } from '@material-ui/core'
import OrganizationsRoutes from 'views/admin/organizations'
import People from 'views/admin/people'
import ScheduleModule from 'views/admin/schedule'
import AcademicRoutes from 'views/admin/academics'
import CommunityRoutes from 'views/admin/community'
import NotificationLogs from 'views/admin/notificationLogs/NotificationLogs'
import OrganizerListing from 'views/admin/conference-organizers/OrganizerListing'

const basePath = '/admin'

export const getConsoleHome = (user) => {
  if (user.role === Roles.SUPER_ADMIN || user.role === Roles.ORGANIZER)
    return `${basePath}/conferences`
  else return `${basePath}/conference/${user.conferenceId}`
}

export const getRoutesBasedOnRole = (role) => {
  if (role === Roles.SUPER_ADMIN) return SuperAdminRoutes
  if (role === Roles.ORGANIZER) return OrganizerRoutes
  return AdminRoutes
}

export const SuperAdminRoutes = [
  {
    name: 'Conferences',
    icon: MeetingRoomOutlined,
    path: `${basePath}/conferences`,
    component: (
      <Container maxWidth="xxl">
        <Conference />
      </Container>
    )
  },
  {
    name: 'Conference Users',
    icon: Group,
    path: `${basePath}/conference-users`,
    component: (
      <Container maxWidth="xxl">
        <Admins />
      </Container>
    )
  },
  {
    name: 'Conference Organizers',
    icon: SupervisorAccount,
    path: `${basePath}/conference-organizers`,
    component: (
      <Container maxWidth="xxl">
        <OrganizerListing />
      </Container>
    )
  },
  {
    name: 'Attendees',
    icon: PeopleOutline,
    path: `${basePath}/attendees`,
    component: (
      <Container maxWidth="xxl">
        <Attendees />
      </Container>
    )
  },
  {
    name: 'Polls',
    icon: HowToVote,
    path: `${basePath}/polls`,
    component: (
      <Container maxWidth="xxl">
        <Polls />
      </Container>
    )
  },
  {
    name: 'Attendance',
    icon: HowToReg,
    path: `${basePath}/attendance`,
    component: (
      <Container maxWidth="xxl">
        <Attendance />
      </Container>
    )
  },
  {
    name: 'Email Templates',
    icon: MailOutline,
    path: `${basePath}/email-templates`,
    component: (
      <Container maxWidth="xxl">
        <DefaultEmailTemplates />
      </Container>
    )
  },
  {
    name: 'App Settings',
    icon: Settings,
    path: `${basePath}/settings`,
    component: (
      <Container maxWidth="xxl">
        <Config />
      </Container>
    )
  }
]

export const OrganizerRoutes = [
  {
    name: 'Conferences',
    icon: MeetingRoomOutlined,
    path: `${basePath}/conferences`,
    component: (
      <Container maxWidth="xxl">
        <Conference />
      </Container>
    )
  },
  {
    name: 'Conference Users',
    icon: Group,
    path: `${basePath}/conference-users`,
    component: (
      <Container maxWidth="xxl">
        <Admins />
      </Container>
    )
  },
  {
    name: 'Attendees',
    icon: PeopleOutline,
    path: `${basePath}/attendees`,
    component: (
      <Container maxWidth="xxl">
        <Attendees />
      </Container>
    )
  }
]

export const AdminRoutes = [
  {
    name: 'Conference',
    icon: MeetingRoomOutlined,
    path: `${basePath}/conference`,
    component: (
      <Container maxWidth="xxl">
        <MyConference />
      </Container>
    )
  },
  {
    name: 'Schedule',
    icon: Event,
    path: `${basePath}/schedule`,
    component: (
      <Container maxWidth="xxl">
        <ScheduleModule />
      </Container>
    )
  },
  {
    name: 'Academics',
    icon: SchoolOutlined,
    path: `${basePath}/academics`,
    component: (
      <Container maxWidth="xxl">
        <AcademicRoutes />
      </Container>
    ),
    visible: ({ conference }) => conference?.enableAcademics || false
  },
  {
    name: 'Buildings',
    icon: Apartment,
    path: `${basePath}/buildings`,
    component: (
      <Container maxWidth="xxl">
        <Building />
      </Container>
    )
  },
  {
    name: 'Organizations',
    icon: CasesOutlined,
    path: `${basePath}/organizations`,
    component: (
      <Container maxWidth="xxl">
        <OrganizationsRoutes />
      </Container>
    )
  },
  {
    name: 'People',
    icon: Group,
    path: `${basePath}/people`,
    component: (
      <Container maxWidth="xxl">
        <People />
      </Container>
    )
  },
  {
    name: 'Community',
    icon: Forum,
    path: `${basePath}/community-posts`,
    component: (
      <Container maxWidth="xxl">
        <CommunityRoutes />
      </Container>
    )
  },
  {
    name: 'Polls',
    icon: HowToVote,
    path: `${basePath}/polls`,
    component: (
      <Container maxWidth="xxl">
        <Polls />
      </Container>
    ),
    visible: ({ conference }) => conference?.havePolls || false
  },
  {
    name: 'Sponsorship Level',
    icon: MilitaryTech,
    path: `${basePath}/sponsorship-level`,
    component: (
      <Container maxWidth="xxl">
        <SponsorshipLevels />
      </Container>
    )
  },
  {
    name: 'Announcements',
    icon: NotificationsActiveOutlined,
    path: `${basePath}/announcements`,
    component: (
      <Container maxWidth="xxl">
        <Announcements />
      </Container>
    )
  },
  {
    name: 'Notification Logs',
    icon: NotificationsNoneOutlined,
    path: `${basePath}/notification-logs`,
    component: (
      <Container maxWidth="xxl">
        <NotificationLogs />
      </Container>
    )
  },
  {
    name: 'Card Color',
    icon: ImageOutlined,
    path: `${basePath}/card-color`,
    component: (
      <Container maxWidth="xxl">
        <EventCards />
      </Container>
    )
  },
  {
    name: 'Attendance',
    icon: HowToReg,
    path: `${basePath}/attendance`,
    component: (
      <Container maxWidth="xxl">
        <Attendance />
      </Container>
    ),
    visible: ({ conference }) => conference?.enableAttendance || false
  },
  {
    name: 'Badges',
    icon: Badge,
    path: `${basePath}/badges`,
    component: (
      <Container maxWidth="xxl">
        <BadgesV1 />
      </Container>
    ),
    visible: ({ conference }) => conference?.enableBadgeModule || false
  },
  {
    name: 'Email Templates',
    icon: MailOutlineIcon,
    path: `${basePath}/email-templates`,
    component: (
      <Container maxWidth="xxl">
        <ConferenceSettings />
      </Container>
    )
  }
]
